<template>
  <div class="row">
    <el-dialog
      left
      title="Confirm Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      :visible.sync="isShow"
      width="80vw"
      class="dialogConfirmCompany"
    >
      <i v-if="isLoading" class="nc-icon nc-refresh-02 spinner"></i>
      <div class="row-wrapper">
        <div
          class="row"
          v-bind:class="{ selected: item.uuid == selectedRadioItem.uuid }"
          v-for="item in cbCompanyList"
          v-bind:key="item.uuid"
          @click="handleRowSelection(item)"
        >
          <div class="col-3 img-with-text">
            <div>
              <l-radio
                v-bind:groupname="'same'"
                v-model="selectedRadioItem"
                v-bind:value="item"
                v-bind:label="item"
              ></l-radio>
            </div>
            <div class="row-img-wrapper">
              <img
                v-bind:src="getImageUrl(item.properties.profile_image_url)"
              />
            </div>
            <div class="name">{{ item.properties.name }}</div>
          </div>

          <div class="col-5">{{ item.properties.short_description }}</div>

          <div class="col-2">{{ companyLocation(item) }}</div>
          <div class="col-2">
            <a v-bind:href="item.properties.homepage_url" target="_blank">{{
              item.properties.homepage_url
            }}</a>
          </div>
        </div>
      </div>

      <div class="row-wrapper" v-if="!isLoading">
        <div
          class="row"
          v-bind:class="{ selected: NONE_SELECTED == selectedRadioItem }"
          v-bind:key="NONE_SELECTED"
          @click="handleRowSelection(NONE_SELECTED)"
        >
          <div class="col-12 img-with-text">
            <div>
              <l-radio
                v-bind:groupname="'same'"
                v-model="selectedRadioItem"
                v-bind:value="NONE_SELECTED"
                v-bind:label="NONE_SELECTED"
              ></l-radio>
            </div>

            <div>{{ noneOption }}</div>
          </div>
        </div>
      </div>

      <div class="btn-wrapper">
        <!--           @click="isShow=false" -->
        <button
          class="todo-form-cancel-button btn-outline-secondary"
          @click="handleCancel"
          style="margin-right: 10px"
        >
          Cancel
        </button>
        <!-- :disabled="selectedRadioItem == ''" -->
        <button
          class="todo-form-submit-button btn btn-primary mb-0"
          :disabled="isDisabled"
          @click="handleConfirm"
        >
          Confirm
          <b-spinner
            v-if="showSpinner"
            style="float: right"
            small
            label="Loading..."
          ></b-spinner>
        </button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import axios from "axios";
import api from "../../../axios_api";
import { Radio } from "src/components/index";
import { Company, patchCompany } from "../../../models/Company";
import config from "../../../../config/settings";
import { cbAdapter } from '../../../util';

const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";

const NONE_SELECTED = "none";

const axiosApi = axios.create({
  baseURL: `${CRUNCHBASE_BASE_URL}`,
});

export default {
  name: "dialogconfirmcompany",
  components: {
    [Dialog.name]: Dialog,
    [Radio.name]: Radio,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
  },
  data: function () {
    return {
      isLoading: false,
      NONE_SELECTED: NONE_SELECTED,
      cbCompanyList2: [],
      selectedRadioItem: "",
      noneOption: "",
      isDisabled: true,
      showSpinner: false,
    };
  },
  computed: {
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    data: {
      get() {
        return this.value.data;
      },
    },
    cbCompanyList: {
      get() {
        return this.cbCompanyList2;
      },
      set(val) {
        this.cbCompanyList2 = val;
      },
    },
    config() {
      return config;
    },
  },
  watch: {
    isShow: function (val) {
      if (val) {
        this.cbCompanyList = [];
        this.getData();
      }
    },
  },
  methods: {
    async getData() {
      this.selectedRadioItem = "";
      this.isLoading = true;

      let responseData = await api.get(`search?key=${this.data.name}`);

      let response = cbAdapter(responseData);

      this.isLoading = false;

      if (response) {
        this.cbCompanyList2 = response.data.items || [];

        this.cbCompanyList2.forEach((item) => {
          if (item) {
            item.isSelected = true;
          }
        });
      }

      if (this.cbCompanyList2.length) {
        this.noneOption = "None of the above. Let me populate data on my own.";
      } else {
        this.noneOption =
          "Information not available. Let me populate data on my own.";
        this.selectedRadioItem = "none";
        this.isDisabled = false;
      }
    },
    handleRowSelection(rowItem) {
      this.selectedRadioItem = rowItem;
      this.isDisabled = false;
    },
    companyLocation(item) {
      let loc = [];
      if (item.properties.city_name) {
        loc.push(item.properties.city_name);
      }
      if (item.properties.region_name) {
        loc.push(item.properties.region_name);
      }
      if (item.properties.country_code) {
        loc.push(item.properties.country_code);
      }
      return loc.length ? loc.join(", ") : "-";
    },
    async handleConfirm() {
      this.isDisabled = true;
      this.showSpinner = true;
      if (this.selectedRadioItem == "none") {
        let serverData = JSON.parse(JSON.stringify(this.data));
        serverData.data_status = "Confirmed";
        serverData.company_status = "Unknown";
        serverData.category_data = "";
        serverData.company_type = "";
        serverData.contact_email = "";
        serverData.description = "";
        serverData.permalink = "";
        serverData.employee_count = "";
        serverData.estimated_revenue_range = "";
        serverData.facebook = "";
        serverData.founding_date = "";
        serverData.fund = "";
        serverData.headquarters = "";
        serverData.ipo_status = "";
        serverData.linkedin = "";
        serverData.stage_i_invested = "";
        serverData.last_funding_round =
          serverData.last_funding_round && serverData.last_funding_round != "-"
            ? serverData.last_funding_round
            : "";
        serverData.initial_investment =
          serverData.initial_investment && serverData.initial_investment != "-"
            ? serverData.initial_investment
            : "";
        const self = this;
        let company = patchCompany(serverData._id);
        if (company.update(serverData)) {
          await company.writeToServer();
        }
      } else {
        let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;
        await api
          .post(url, {
            encrypt: {
              data: {
                company: this.data,
                confirmedCompany: this.selectedRadioItem,
              },
            },
          })
          .catch((e) => {
            console.error("error: ", e);
          });
      }
      //this.isShow = false;
      if (this.$parent.activeDiligenceData) {
        this.$store.dispatch("diligence/apiFetchDiligence").then((data) => {
          if (this.$parent && this.$parent.tabulator) {
            let data = this.$store.getters["diligence/activeDiligenceData"];
            this.$parent.tabulator.updateData(data);
            this.$parent.checkDataStatus();
            this.$toaster.success("Saved Successfully");
            this.handleCancel();
          }
        });
      } else {
        this.$store.dispatch("portfolio/_apiFetchPortfolio").then((data) => {
          if (this.$parent && this.$parent.tabulator) {
            let data = this.$store.getters["portfolio/portfolioData"];
            this.$parent.tabulator.updateData(data);
            this.$parent.checkDataStatus();
            this.$toaster.success("Saved Successfully");
            this.handleCancel();
          }
        });
      }
    },
    handleCancel() {
      this.isDisabled = true;
      this.showSpinner = false;
      this.isShow = false;
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  text-align: left;
}
.row-img-wrapper {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.img-with-text {
  display: flex;
  flex-direction: row;
  align-items: center;
  .row-img-wrapper {
    margin-left: 20px;
  }
  .name {
    margin-left: 10px;
  }
}

.row-wrapper {
  width: 100%;
  text-align: center;
  word-break: normal;
  max-height: 50vh;
  overflow: auto;
  .row {
    padding: 5px 10px;
    vertical-align: middle;
    display: flex;
    align-items: center;
    word-break: break-all;
    transition: all 0.3s ease 0.1s;
    border-bottom: 1px solid #f5f5f5;
    min-height: 55px;
    width: 100%;
    margin: 0;
  }
  .row.selected,
  .row:hover {
    background-color: #d1ebee;
    cursor: pointer;
    border-radius: 10px;
  }
  .row:hover {
    background-color: #d1ebee9c;
  }
}

.btn-wrapper {
  display: flex;
  min-height: 70px;
  justify-content: center;
  align-items: flex-end;
}
</style>